import styled, { css } from 'styled-components';
import { Button } from 'antd';

const ACTION_HEIGHT = '2.5rem';
const ACTION_ICON_SIZE = '1.5rem';
const NAV_BUTTON_SIZE = '2.5rem';
const DOWNLOAD_SHADOW = '0 0.125rem 0 rgba(0, 0, 0, 0.02)';

const actionBase = css`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	box-shadow: none;

	svg {
		width: ${ACTION_ICON_SIZE};
		height: ${ACTION_ICON_SIZE};
	}
`;

export const Content = styled.div`
	padding: 2.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	border-radius: 1rem;
`;

export const DownloadButton = styled(Button)`
	${actionBase}
	gap: 1rem;
	width: 10rem;
	height: ${ACTION_HEIGHT};
	padding: 0 1.0625rem;
	border: 1px solid ${({ theme }) => theme.palette.primary[600]};
	border-radius: 0.125rem;
	box-shadow: ${DOWNLOAD_SHADOW};
	color: ${({ theme }) => theme.palette.primary[600]};
	font-size: 1rem;
	line-height: 1.5rem;

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.secondary.white};
		border-color: ${({ theme }) => theme.palette.primary[600]};
		color: ${({ theme }) => theme.palette.primary[600]};
	}

`;

export const ConsolidateButton = styled(Button)`
	${actionBase}
	gap: 0.25rem;
	width: 11.875rem;
	height: ${ACTION_HEIGHT};
	border: 1px solid ${({ theme }) => theme.palette.risk.low.default};
	border-radius: 0.25rem;
	color: ${({ theme }) => theme.palette.risk.low.default};
	font-size: 1rem;
	line-height: 1.5rem;
	letter-spacing: -0.005rem;

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.secondary.white};
		border-color: ${({ theme }) => theme.palette.risk.low.default};
		color: ${({ theme }) => theme.palette.risk.low.default};
	}

`;

export const NavButton = styled(Button)`
	${actionBase}
	width: ${NAV_BUTTON_SIZE};
	height: ${NAV_BUTTON_SIZE};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	border-radius: 0.25rem;
	color: ${({ theme }) => theme.palette.secondary[400]};

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.secondary.white};
		border-color: ${({ theme }) => theme.palette.primary[600]};
		color: ${({ theme }) => theme.palette.primary[600]};
	}

`;

